import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  doc,
  getDoc
} from "firebase/firestore";

import { db } from "../firebase";

import "./OrderView.css";



export default function OrderView(){


  const { id } = useParams();


  const [order,setOrder] = useState(null);

  const [loading,setLoading] = useState(true);





  useEffect(()=>{


    const getOrder = async()=>{


      try{


        const orderRef = doc(
          db,
          "orders",
          id
        );



        const orderSnap = await getDoc(orderRef);



        if(orderSnap.exists()){


          setOrder({

            id: orderSnap.id,

            ...orderSnap.data()

          });


        }


        else{


          console.log("Order not found");


        }



      }

      catch(error){


        console.log(error);


      }



      setLoading(false);



    };



    getOrder();



  },[id]);









  if(loading){


    return (

      <div className="order-loading">

        Loading CUTIES Order 🧸

      </div>

    );


  }







  if(!order){


    return (

      <div className="order-error">

        Order not found ❌

      </div>

    );


  }









  return (


    <div className="order-page">


      <div className="order-container">





        {/* HEADER */}

        <div className="order-header">


          <h1>

            CUTIES 🧸

          </h1>


          <p>

            Order Details

          </p>


        </div>








        {/* CUSTOMER */}


        <div className="customer-box">


          <h2>

            👤 Customer

          </h2>




          <p>

            <b>Name:</b>{" "}

            {order.customer?.name || "-"}

          </p>





          <p>

            <b>Phone:</b>{" "}

            {order.customer?.phone || "-"}

          </p>





          <p>

            <b>Address:</b>{" "}

            {order.customer?.address || "-"}

          </p>







          {

            order.customer?.location &&


            <p>


              📍{" "}


              <a

                href={order.customer.location}

                target="_blank"

                rel="noreferrer"

              >

                Open Location

              </a>


            </p>


          }





        </div>









        {/* PRODUCTS */}



        <h2 className="products-title">

          🛍 Products

        </h2>







        <div className="products-grid">





          {

            order.products?.map((item,index)=>(



              <div

                className="order-product-card"

                key={index}

              >





                <img

                  src={

                    item.image ||

                    item.images?.[0] ||

                    "/no-image.png"

                  }

                  alt={item.name}

                />







                <div className="product-info">





                  <h3>

                    {item.name}

                  </h3>






                  <p>

                    🎨 Color:

                    {" "}

                    {item.color || "-"}

                  </p>







                  <p>

                    📏 Size:

                    {" "}

                    {item.size || "-"}

                  </p>







                  <p>

                    📦 Quantity:

                    {" "}

                    {item.quantity}

                  </p>







                  <p className="product-price">

                    💰

                    {" "}

                    {item.price}$

                  </p>






                </div>




              </div>



            ))


          }




        </div>










        {/* TOTAL */}



        <div className="total-box">


          Total:


          <span>

            {order.total}$

          </span>



        </div>






      </div>


    </div>


  );


}